var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-nav'),(this.$route.name == 'admin-lms-users')?_c('lms-users-index'):_vm._e(),(this.$route.name == 'admin-lms-user')?_c('lms-user-edit'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }